import { Component, OnInit, Inject } from '@angular/core';
import { Furnisher, FurnisherService } from 'src/api/api.services';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FurnishersComponent } from '../furnishers/furnishers.component';
import { getAccountingId } from 'src/api/api-local';

@Component({
  selector: 'app-furnisher-edit',
  templateUrl: './furnisher-edit.component.html',
  styleUrls: ['./furnisher-edit.component.css']
})
export class FurnisherEditComponent implements OnInit {

  public furnisher: Furnisher;
  private furnisherId: any;

  public form: FormGroup = this.formBuilder.group({
    companyName: [null, Validators.required],
    firstName: [null],
    lastName: [null],
    companyIdentificationNumber: [null],
    address: [null],
    contact: [null],
  });

  constructor(
    private furnisherService: FurnisherService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FurnishersComponent>,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.furnisherId = this.data;
    this.furnisherService.getFurnisher(this.furnisherId).subscribe(res => {
      this.furnisher = res;
      this.form = this.formBuilder.group({
        companyName: [this.furnisher.companyName, Validators.required],
        firstName: [this.furnisher.firstName],
        lastName: [this.furnisher.lastName],
        companyIdentificationNumber: [this.furnisher.companyIdentificationNumber],
        address: [this.furnisher.address],
        contact: [this.furnisher.contact],
      });
    });

  }

  openSnackBar(message: string, className: string) {
    this._snackBar.open(message, null, {
      duration: 2000,
      panelClass: [className]
    });
  }

  submit() {
    var isCorrect: boolean = false;
    var iceNumber = this.form.value.companyIdentificationNumber;
    var companyName = this.form.value.companyName;
    var firstName = this.form.value.firstName;
    var lastName = this.form.value.lastName;
    var addressF = this.form.value.address;
    var contactF = this.form.value.contact;
    if (companyName != null) {
      companyName = companyName.toUpperCase();
    }
    if (iceNumber != null) {
      if (iceNumber.length == 0) {
        iceNumber = null;
      }else{
        iceNumber = iceNumber.toUpperCase();
      }
    }
    if (firstName != null) {
      if (firstName.length == 0) {
        firstName = null;
      } else {
        firstName = firstName.toUpperCase();
      }
    }
    if (lastName != null) {
      if (lastName.length == 0) {
        lastName = null;
      } else {
        lastName = lastName.toUpperCase();
      }
    }
    if (addressF != null) {
      if (addressF.length == 0) {
        addressF = null;
      } else {
        addressF = addressF.toUpperCase();
      }
    }
    if (contactF != null) {
      if (contactF.length == 0) {
        contactF = null;
      }
    }
    var furnisher: Furnisher = new Furnisher({
      furnisherId: this.furnisherId,
      companyName: companyName,
      firstName: firstName,
      lastName: lastName,
      companyIdentificationNumber: iceNumber,
      address: addressF,
      contact: contactF,
      creationDate: this.furnisher.creationDate,
      createdByUserId: this.furnisher.createdByUserId,
    });

    this.furnisherService.furnisherPut(furnisher).subscribe(res => {
      isCorrect = true;
      this.openSnackBar("Fournisseur modifié", "snackbarCorrect")
      this.dialogRef.close(isCorrect);
    }, err => this.openSnackBar("Erreur", "snackbarError"));
  }

}
